import React, { Component } from "react";
import { connect } from "react-redux";
import {
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";

import { req_page_lrs_lend, req_edit_lrs_lend } from "../../api";
import {
  Table,
  Select,
  Input,
  Card,
  Button,
  Tag,
  Tooltip,
  Modal,
  Popconfirm,
  message,
} from "antd";

import ConfirmorReviewWorkflow from "./confirmor-review-workflow";

class UserBorrowLog extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",
    selectedRowKeys: [],
    domnloadFile: "",
    confirmLevel: "OWN", //篩選為個人或跟自己有相關的申請紀錄
    isShowWorkflowModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      confirmLevel,
    } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [], selectedRowKeys: [] });
    const result = await req_page_lrs_lend(
      userLevel,
      userCode,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      confirmLevel,
      token
    );
    this.setState({ loading: false });
    //console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
  };

  api_modify_item = async (item) => {
    const { token, userCode, userName } = this.props.user;
    const { Uid, BorrowerEmail } = item;

    //console.log(applycase)
    const row = {
      condition: "BASE",
      Uid: Uid,
      BorrowerId: userCode,
      BorrowerName: userName,
      BorrowerEmail: BorrowerEmail,
      ApplyStatus: "CANCEL",
    };
    const result = await req_edit_lrs_lend(row, token);
    //console.log(result);
    if (result.status === "success") {
      message.success("註銷成功");
      this.api_page_items(this.current);
    } else {
      message.error(result.message);
    }
  };

  api_edit_item = async (item) => {
    const { token } = this.props.user;
    //console.log(applycase)

    const result = await req_edit_lrs_lend(item, token);
    //console.log(result);
    if (result.status === "success") {
      this.api_page_items(this.current);
    } else {
      message.error(result.message);
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "申請編號",
        dataIndex: "ApplyNumber",
        width: 40,
        responsive: ["md"],
      },
      {
        title: "申請人",
        dataIndex: "OperatorName",
        width: 30,
        responsive: ["md"],
      },
      {
        title: "使用人",
        dataIndex: "BorrowerName",
        width: 30,
        responsive: ["md"],
      },
      {
        title: "使用人電話",
        dataIndex: "BorrowerPhone",
        width: 30,
        responsive: ["md"],
      },
      {
        title: "使用空間",
        width: 50,
        render: (item) => {
          const { RoomCode, RoomName } = item;
          return (
            <span>
              {RoomCode}-{RoomName}
            </span>
          );
        },
      },
      {
        title: "使用日期",
        width: 50,
        render: (item) => {
          const { DateTag, WeekCode, TimeStart, TimeEnd } = item;
          return (
            <>
              <span>
                {DateTag}({WeekCode})
              </span>
              <br></br>
              <span>
                {TimeStart}-{TimeEnd}
              </span>
            </>
          );
        },
      },
      {
        title: "狀態",
        width: 25,
        render: (item) => {
          const { ApplyStatus, MustConfirmLevel, ReviewStatus } = item;
          return (
            <>
              {ReviewStatus === "REVIEW" ? (
                <>
                  <Tag
                    color={this.style_switch_color("APPLY_STATUS", ApplyStatus)}
                  >
                    {this.style_switch_text("APPLY_STATUS", ApplyStatus)}
                  </Tag>
                  {ApplyStatus === "CANCEL" ? (
                    ""
                  ) : (
                    <>
                      <Tag
                        color={this.style_switch_color(
                          "CONFIRM_LEVEL",
                          MustConfirmLevel
                        )}
                      >
                        {this.style_switch_text(
                          "CONFIRM_LEVEL",
                          MustConfirmLevel
                        )}
                      </Tag>
                    </>
                  )}
                </>
              ) : (
                <>
                  <Tag
                    color={this.style_switch_color(
                      "RESULT_STATUS",
                      ApplyStatus
                    )}
                  >
                    {this.style_switch_text("RESULT_STATUS", ApplyStatus)}
                  </Tag>
                </>
              )}
            </>
          );
        },
      },
      {
        title: "",
        width: 35,
        render: (item) => {
          const {
            ApplyStatus,
            // ReviewStatus,
            NeedSignInOut,
            SignInTime,
            SignOutTime,
          } = item;
          // const IsAgree =
          //   ApplyStatus.substring(0, 5) === "AGREE" ? true : false;
          return (
            <>
              <Button onClick={() => this.handle_show_ui_workflow_case(item)}>
                <i className="fa fa-list"></i> 歷程
              </Button>
              {ApplyStatus === "APPLY" ? (
                <>
                  {" "}
                  <Popconfirm
                    title="您確定要註銷此申請?"
                    onConfirm={() => this.handle_delete_cace(item)}
                    okText="是"
                    cancelText="否"
                  >
                    <Button>
                      <i className="fa fa-minus"></i> 註銷
                    </Button>
                  </Popconfirm>
                </>
              ) : (
                ""
              )}
              {//ReviewStatus === "END" && IsAgree && NeedSignInOut === "YES" ? (
              NeedSignInOut === "YES" && (ApplyStatus === "APPLY" || ApplyStatus === "AGREEA" || ApplyStatus === "AGREEB" || ApplyStatus === "AGREEC")? (
                <>
                  {SignInTime.substring(0, 10) === "1999-01-01" ? (
                    <Button
                      onClick={() => this.handle_sign_event("SIGNIN", item)}
                    >
                      <i className="fas fa-sign-in-alt"></i> 簽到
                    </Button>
                  ) : (
                    <>
                      {SignOutTime.substring(0, 10) === "1999-01-01" ? (
                        <Button
                          onClick={() =>
                            this.handle_sign_event("SIGNOUT", item)
                          }
                        >
                          <i className="fas fa-sign-out-alt"></i> 簽退
                        </Button>
                      ) : (
                        <Button disabled={true}>已離退</Button>
                      )}
                    </>
                  )}
                </>
              ) : (
                ""
              )}
            </>
          );
        },
      },
    ];
  };

  style_switch_color(type, param) {
    switch (type) {
      case "CONFIRM_LEVEL":
        switch (param) {
          case "A":
            return "PowderBlue";
          case "B":
            return "LightSkyBlue";
          case "C":
            return "DarkBlue";
          default:
            return "Black";
        }
      case "APPLY_STATUS":
        switch (param) {
          case "APPLY":
            return "DarkSlateBlue";
          case "AGREEA":
            return "PaleGreen";
          case "AGREEB":
            return "OliveDrab";
          case "AGREEC":
            return "DarkGreen";
          case "REFUSEA":
            return "DarkGray";
          case "REFUSEB":
            return "DimGray";
          case "REFUSEC":
            return "Black";
          case "CANCEL":
            return "SlateGray";
          default:
            return "Black";
        }
      case "RESULT_STATUS":
        switch (param) {
          case "APPLY":
            return "DarkSlateBlue";
          case "AGREEA":
          case "AGREEB":
          case "AGREEC":
            return "Green";
          case "REFUSEA":
          case "REFUSEB":
          case "REFUSEC":
            return "Black";
          case "CANCEL":
            return "SlateGray";
          default:
            return "Black";
        }
      default:
        return "Black";
    }
  }

  style_switch_text(type, param) {
    switch (type) {
      case "CONFIRM_LEVEL":
        switch (param) {
          case "A":
            return "只要一審";
          case "B":
            return "須到二審";
          case "C":
            return "須到三審";
          default:
            return "未定義";
        }
      case "APPLY_STATUS":
        switch (param) {
          case "APPLY":
            return "申請中";
          case "AGREEA":
            return "一審已同意";
          case "AGREEB":
            return "二審已同意";
          case "AGREEC":
            return "三審已同意";
          case "REFUSEA":
            return "一審不同意";
          case "REFUSEB":
            return "二審不同意";
          case "REFUSEC":
            return "三審不同意";
          case "CANCEL":
            return "已註銷";
          default:
            return "未定義";
        }
      case "RESULT_STATUS":
        switch (param) {
          case "APPLY":
            return "待審";
          case "AGREEA":
          case "AGREEB":
          case "AGREEC":
            return "同意";
          case "REFUSEA":
          case "REFUSEB":
          case "REFUSEC":
            return "不同意";
          case "CANCEL":
            return "已註銷";
          default:
            return "Black";
        }
      default:
        return "Black";
    }
  }

  // 操作互動處理 //////////////////////////////////////////////

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  onSelectChange = (selectedRowKeys) => {
    //console.log("selectedRowKeys changed: ", selectedRowKeys);
    this.setState({ selectedRowKeys });
  };

  handle_show_ui_workflow_case = (item) => {
    // console.log(item);
    this.setState({ isShowWorkflowModal: true, item: item });
  };

  handle_delete_cace = (item) => {
    //console.log(item);
    this.api_modify_item(item);
  };

  handle_sign_event = (type, item) => {
    const { Uid } = item;
    const row = {
      condition: type,
      Uid: Uid,
    };
    this.api_edit_item(row);
  };

  //////////////////////////////////////////////////////////
  render() {
    const {
      loading,
      items,
      pagination,
      searchField,
      searchValue,
      isShowWorkflowModal,
    } = this.state;
    const { Uid } = this.state.item;
    const title = (
      <span>
        <Select
          value={searchField}
          style={{ width: 100 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="RoomCode">空間編號</Select.Option>
          <Select.Option value="DateTag">借用日期</Select.Option>
          <Select.Option value="ApplyNumber">案件編號</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 100, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search"></i> 查詢
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>
        <p></p>
      </span>
    );

    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Uid"
          columns={this.columns}
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
        />
        <Modal
          destroyOnClose={true}
          visible={isShowWorkflowModal}
          width={400}
          onOk={() => {
            this.setState({ isShowWorkflowModal: false });
          }}
          onCancel={() => {
            this.setState({ isShowWorkflowModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <ConfirmorReviewWorkflow CaseId={Uid} />
        </Modal>
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(UserBorrowLog);
